<p-button
  (onClick)="handleTogglePopoverClick($event)"
  [text]="true"
  appPrimengButton
  pTooltip="Ustawienia"
  tooltipPosition="left">
  <app-icon [icon]="Icon.Sliders" />
</p-button>

<p-popover>
  <p-button
    (onClick)="handleClearSortClick()"
    [text]="true"
    appPrimengButton
    label="Usuń sortowania"
    size="small">
    <app-icon
      [icon]="Icon.ArrowDownUp"
      class="mr-2" />
  </p-button>
</p-popover>
